import React ,{ useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import lineup from "./Main_assets/lineup.png";
import poster from "./Main_assets/poster.png";
import footer from "./Main_assets/footer_img.png";
import booth from "./Main_assets/부스정보.png";
import mapinfo from "./Main_assets/지도정보.jpg";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./Main.css";



const MIN_SPEED = 1.0;
const MAX_SPEED = 2.0;

function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

class Blob {
  constructor(el) {
    this.el = el;
    const boundingRect = this.el.getBoundingClientRect();
    this.size = boundingRect.width;
    this.initialX = randomNumber(0, window.innerWidth - this.size);
    this.initialY = randomNumber(0, window.innerHeight - this.size);
    this.el.style.top = `${this.initialY}px`;
    this.el.style.left = `${this.initialX}px`;
    this.vx = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.vy = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.x = this.initialX;
    this.y = this.initialY;
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    if (this.x >= window.innerWidth - this.size) {
      this.x = window.innerWidth - this.size;
      this.vx *= -1;
    }
    if (this.y >= window.innerHeight - this.size) {
      this.y = window.innerHeight - this.size;
      this.vy *= -1;
    }
    if (this.x <= 0) {
      this.x = 0;
      this.vx *= -1;
    }
    if (this.y <= 0) {
      this.y = 0;
      this.vy *= -1;
    }
  }

  move() {
    this.el.style.transform = `translate(${this.x - this.initialX}px, ${this.y - this.initialY}px)`;
  }
}




const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

export const Main = () => {

  useEffect(() => {
    const initBlobs = () => {
      const blobEls = document.querySelectorAll('.bouncing-blob');
      const blobs = Array.from(blobEls).map((blobEl) => new Blob(blobEl));

      function update() {
        requestAnimationFrame(update);
        blobs.forEach((blob) => {
          blob.update();
          blob.move();
        });
      }

      requestAnimationFrame(update);
    };

    initBlobs();
  }, []);
  return (
    <div className="page2">
      

      <div className="slider-container">
        <Slider {...settings} arrows={false}>
          <Link to = '/centerstage1'>
          <div>
            <img src={lineup} alt="lineup" className="img2" />
          </div>
          </Link>
          <Link to = "/booth-info">
          <div>
            <img src={booth} alt="booth" className="img2"/>
          </div>
          </Link>
          <Link to = "/map">
          <div>
            <img src={mapinfo} alt="map" className="img2"/>
          </div>
          </Link>
          <Link to = "/notice" className="img2">
          <div>
            <img src={poster} alt="info" className="img2"/>
          </div>
          </Link>
          


        </Slider>
      </div>

      <div className="select">
        <div className="info_text">information</div>
        <Link to="/notice" className="box_text link">
          공지사항
          <div className="box_text_2">Notice</div>
        </Link>
        <Link to="/performance" className="box_text link">
          공연
          <div className="box_text_2">Performance</div>
        </Link>
        <Link to="/map" className="box_text link">
          학교지도
          <div className="box_text_2">Map</div>
        </Link>
        <Link to="/booth-info" className="box_text link">
          부스정보
          <div className="box_text_2">Booth Information</div>
        </Link>
      </div>

      <div className="bouncing-blobs-container">
        <div className="bouncing-blobs-glass"></div>
        <div className="bouncing-blobs">
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--white"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--pink"></div>
        </div>
      </div>
      <div className="hero"></div>

      <img className="footer"src = {footer} alt ="footer"/>

    </div>
  );
};

export default Main;
